import { isEmpty, uniq } from 'lodash';
import { GetListParams, GetListResult } from 'react-admin';
import { getClientApi } from 'src/data-communication';
import { QuoteDto } from 'src/dtos';
import { mapGetOrderListResponseDtoToModel } from 'src/mappers';
import { Order } from 'src/models';

const clientApi = getClientApi();

export const getOrderList = async (params: GetListParams): Promise<GetListResult<Order>> => {
  const { accountId } = params.meta;

  const { data, total } = await clientApi.orders.list({
    params: {
      accountId,
    },
    queryParams: {
      pageIndex: params.pagination.page === 1 ? 0 : params.pagination.page - 1,
      pageSize: params.pagination.perPage ?? 10,
    },
  });

  const symbols: string[] = data.reduce((all: string[], current) => {
    if (current.UnderlyingSymbol) {
      all.push(current.UnderlyingSymbol);
    }

    return all;
  }, []);
  let snapQuotes: QuoteDto[] = [];

  try {
    if (!isEmpty(symbols)) {
      const quoteListResponse = await clientApi.quote.list({
        queryParams: {
          symbols: uniq(symbols).join(','),
        },
      });
      snapQuotes = quoteListResponse.data;
    }
  } catch (error) {
    // TODO: replace console logs with logger
    // eslint-disable-next-line no-console
    console.error('Error fetching quote media snap.');
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return {
    data: mapGetOrderListResponseDtoToModel(data, snapQuotes),
    total,
  };
};
